export enum ProgressStatusEnum {
  DONE = 'done',
  WARNING = 'warning',
  ERROR = 'error'
}
